<span *ngIf="!hideLabel">Type:&nbsp;&nbsp;</span>
<mat-form-field appearance="standard">
  <mat-select [(ngModel)]="licenseType" (ngModelChange)="onChanged()">
    <mat-option *ngFor="let _type of types" [value]="_type.enum">
      {{ _type.abbr }}
    </mat-option>
  </mat-select>
</mat-form-field>
